import * as React from "react";
import {translate} from 'react-i18next';

// reducer
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

// services
import {ResourceListOfModelyearDto, ModelyearDto} from "../../services/Client";
import ColumnFactory from "../../services/ColumnFactory";

// components
import SelectField from "../../components/SelectField";

interface IModelyearCopyControlProps extends ITranslatedComponent {
    /** All available model years available for selection. */
    modelyears: ResourceListOfModelyearDto | ModelyearDto[];

    /** The selected item used as source for copying. */
    srcItem?: ModelyearDto;

    /** The selected item used as destination for copying. */
    dstItem?: ModelyearDto;

    /** Callback for when the 'copy' button is pressed. */
    selectionChanged: (src?: ModelyearDto, dst?: ModelyearDto) => any;
}

interface IModelyearCopyControlState {
    /** Available model years. */
    modelyears: ModelyearDto[];
}

class ModelyearCopyControl extends React.Component<IModelyearCopyControlProps, IModelyearCopyControlState> {
    constructor(props: IModelyearCopyControlProps) {
        super(props);
        this.state = {
            modelyears: this.getModelyearElements(props.modelyears),
        };
    }

    componentWillReceiveProps(newProps: IModelyearCopyControlProps) {
        this.setState({modelyears: this.getModelyearElements(newProps.modelyears)});
    }

    getModelyearElements = (modelyears: ResourceListOfModelyearDto | ModelyearDto[]): ModelyearDto[] => {
        const isResList = (x: ResourceListOfModelyearDto | ModelyearDto[]): x is ResourceListOfModelyearDto => (
            (x as ResourceListOfModelyearDto).elements !== undefined
        );
        if (isResList(modelyears)) {
            return modelyears.elements || [];
        }
        if (Array.isArray(modelyears)) {
            return modelyears;
        }
        throw new Error("Invalid model year type");
    }

    onSrcSelectionChanged = (selectedValue?: ModelyearDto, selectedIndex?: number) => {
        if (selectedValue !== undefined) {
            if (this.props.dstItem && this.props.dstItem.mj1 === selectedValue.mj1) {
                this.props.selectionChanged(selectedValue, undefined);
            } else {
                this.props.selectionChanged(selectedValue, this.props.dstItem);
            }
        }
    }

    onDstSelectionChanged = (selectedValue?: ModelyearDto, selectedIndex?: number) => {
        if (selectedValue !== undefined) {
            this.props.selectionChanged(this.props.srcItem, selectedValue);
        }
    }

    renderSrcControl = (): JSX.Element => {
        return (
            <SelectField
                placeholder={this.props.t("SOURCE_MODELYEAR")}
                searchable={false}
                clearable={false}
                onChange={this.onSrcSelectionChanged}
                dataSource={this.state.modelyears}
                value={this.props.srcItem}
                rendererKey={(dto: ModelyearDto) => ColumnFactory.mj2str(dto)}
            />
        );
    }

    renderDstControl = (): JSX.Element => {
        const srcItem = this.props.srcItem;
        let dataSource = this.state.modelyears;
        if (srcItem) {
            dataSource = dataSource.filter(dto => dto.mj1 !== srcItem.mj1);
        }
        return (
            <SelectField
                placeholder={this.props.t("TARGET_MODELYEAR")}
                searchable={false}
                clearable={false}
                onChange={this.onDstSelectionChanged}
                dataSource={dataSource}
                value={this.props.dstItem}
                rendererKey={(dto: ModelyearDto) => ColumnFactory.mj2str(dto)}
            />
        );
    }

    render() {
        return (
            <>
                {this.renderSrcControl()}
                <br/><br/>
                {this.renderDstControl()}
            </>
        );
    }
}

export default translate("GLOBAL")(ModelyearCopyControl);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/ModelyearCopyControl.tsx